import { render, staticRenderFns } from "./ReportNoteCredit.vue?vue&type=template&id=638768fc&scoped=true"
import script from "./ReportNoteCredit.vue?vue&type=script&lang=js"
export * from "./ReportNoteCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638768fc",
  null
  
)

export default component.exports